import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useI18n } from "../i18n/LanguageContext";

const LINKS = [
  { key: "how", href: "#how" },
  { key: "search", href: "#search-panel" },
  { key: "results", href: "#results-preview" },
  { key: "technology", href: "#technology" },
];

export const Navbar = () => {
  const { t } = useI18n();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 flex justify-center px-4 pt-4"
    >
      <nav
        data-testid="main-navbar"
        className={`flex items-center justify-between w-full max-w-6xl rounded-full px-5 py-3 transition-[background,box-shadow,border] duration-500 ${
          scrolled ? "glass cyan-glow" : "bg-transparent border border-transparent"
        }`}
      >
        <Logo />
        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="font-mono text-[13px] text-[#A7B4C2] hover:text-[#4BE3FF] transition-colors duration-300"
            >
              {t(`nav.${l.key}`)}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a
            href="#hero-search"
            data-testid="nav-cta"
            className="group hidden sm:flex items-center gap-1.5 rounded-full bg-[#1E6FFF] hover:bg-[#4BE3FF] hover:text-[#0A1A2F] text-white font-mono text-[13px] px-4 py-2 transition-colors duration-300"
          >
            {t("nav.launch")}
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </nav>
    </motion.header>
  );
};
